module.exports = __webpack_public_path__ + "static/media/slide-04.a7130a02.jpg";